<div class="entity-associated-info-container" loading-spin [isLoading]="isPageLoading" [loadingSize]="'big'">
    <div class="header">
        <div class="h3-regular title">
            Deleting&nbsp;<span *ngIf="entityInfo.shortName && !entityInfo.isPublic" class="item-lock">
                <smart-icon name="locked" class="light"></smart-icon>
            </span>&nbsp;{{pageTitle}}
        </div>
        <div class="action">
            <span class="h3-regular"><button tam-button [tamType]="'destructive'" [tamSize]="'normal'"
                    (click)="onDelete()">DELETE</button></span>
            <button tam-button tamType="tertiary" tamSize="normal" (click)="onBackClick()">
                {{'general.back' |stringLiterals}}
            </button>
        </div>
    </div>
    <div>
        <div class="tab-box">
            <tabs [options]="tabsOptions" [underlineStyle]="true" tid="Associated_entries_tabs"></tabs>
        </div>
        <div [style.display]="currentTab===0 ? '' : 'none'" class="tab-sub-item">
            <div class="body">
                <div *ngFor="let item of configData"
                    [ngClass]="{'grid-0-empty': this.configData.length ===4, 'grid-1-empty':this.configData.length ===3, 'grid-2-empty':this.configData.length ===2, 'grid-3-empty':this.configData.length ===1}">
                    <div class="grid-title">
                        <span class="title">{{item.name}}</span>
                    </div>
                    <div class="grid-header">
                        <span class="body-2">{{item.displayDataCount}} items</span>&nbsp;
                        <smart-icon name="refresh" class="light refresh" kendoTooltip position="left"
                            title="{{'general.refresh' | stringLiterals}}"
                            (click)="refreshGrid($event, item)"></smart-icon>
                        <smart-icon name="export-excel" class="light" kendoTooltip position="left"
                            title="{{'general.export_to_excel' | stringLiterals}}"
                            (click)="showContextMenu($event, item)" *ngIf="item.id==='ENTRY'"></smart-icon>
                        <smart-icon name="export-excel" class="light" kendoTooltip position="left"
                            title="{{'general.export_to_excel' | stringLiterals}}" (click)="exportToExcel(item)"
                            *ngIf="item.id!=='ENTRY'"></smart-icon>
                        <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
                    </div>
                    <div style="width: 100%; height: 100%;" *ngIf="!item.isDataLoading">
                        <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham"
                            [columnDefs]="item.columnDefs" [rowData]="item.rowData" [gridOptions]="gridOptions"
                            (gridReady)="onGridReady($event, item.id)" (filterChanged)="item.onFilterChanged($event)">
                        </ag-grid-angular>
                    </div>
                </div>
                <div class="no-data">
                    <div *ngFor="let item of configEmptyData" class="row-title">
                        <span class="title">{{item.name}}</span>
                        <span class="content">No Data Found</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="currentTab===1" class="tab-sub-item">
            <div class="body">
                <div *ngFor="let item of configImpactedData"
                    [ngClass]="{'grid-4-empty': this.configImpactedData.length ===1}">
                    <div class="grid-header">
                        <span class="body-2">{{item.displayDataCount}} items</span>&nbsp;
                        <smart-icon name="refresh" class="light refresh" kendoTooltip position="left"
                            title="{{'general.refresh' | stringLiterals}}"
                            (click)="refreshGrid($event, item)"></smart-icon>
                        <smart-icon name="export-excel" class="light" kendoTooltip position="left"
                            title="{{'general.export_to_excel' | stringLiterals}}"
                            (click)="showContextMenu($event, item)" *ngIf="item.id==='ENTRY'"></smart-icon>
                        <smart-icon name="export-excel" class="light" kendoTooltip position="left"
                            title="{{'general.export_to_excel' | stringLiterals}}" (click)="exportToExcel(item)"
                            *ngIf="item.id!=='ENTRY'"></smart-icon>
                        <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
                    </div>
                    <div style="width: 100%; height: 100%;" *ngIf="!item.isDataLoading">
                        <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham"
                            [columnDefs]="item.columnDefs" [rowData]="item.rowData" [gridOptions]="gridOptions"
                            (gridReady)="onGridReady($event, item.id)" (filterChanged)="item.onFilterChanged($event)">
                        </ag-grid-angular>
                    </div>
                </div>
                <div class="no-data">
                    <div *ngFor="let item of configImpactEmptyData" class="row-title">
                        <span class="title">{{item.name}}</span>
                        <span class="content">No Data Found</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>